import { render, staticRenderFns } from "./axisLine.md?vue&type=template&id=4f5b64c4&"
import script from "./axisLine.md?vue&type=script&lang=js&"
export * from "./axisLine.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f5b64c4')) {
      api.createRecord('4f5b64c4', component.options)
    } else {
      api.reload('4f5b64c4', component.options)
    }
    module.hot.accept("./axisLine.md?vue&type=template&id=4f5b64c4&", function () {
      api.rerender('4f5b64c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/line/axisLine.md"
export default component.exports